import { FilterTemplate } from '../types/filter-template';

export abstract class FilterTemplateRepository {
  abstract loadGroup(groupKey: string): Promise<FilterTemplate[]>;
  abstract create(template: FilterTemplate): Promise<FilterTemplate>;
  abstract update(id: string, template: FilterTemplate): Promise<FilterTemplate>;
  abstract patch(id: string, changes: Partial<FilterTemplate>): Promise<FilterTemplate>;
  abstract delete(id: string): Promise<FilterTemplate>;
}
